// src/services/api/publicInvoice.js
// No auth required — uses a plain fetch so auth interceptors don't interfere.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getPublicInvoice = async (token) => {
  const response = await fetch(`${API_BASE}/public/invoice/${encodeURIComponent(token)}`);

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || 'Invoice not found');
  }

  return response.json();
};
